export default __webpack_public_path__ + "static/media/messageIcon.a6ddab93.svg";